import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { decodeTestToken } from "../../utils/tokenUtils";
import { SD_PENDING_KEY } from "../../utils/selfDiscovery";
import SignIn from "../../Login";

// Mounted at BOTH:
//   /self-discovery/test?token=...          (private, OTP)
//   /self-discovery/public/test?token=...   (public, common invite)
//
// Everything goes through the SAME login page — this component doesn't
// render its own form. Its only job is: decode the token, stash it so
// Login.jsx knows where to send the user after a successful sign-in, and
// render <SignIn />. If the person already has an active session, skip the
// login form entirely and jump straight to /self-discovery/continue.
export default function SelfDiscoveryGate() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();
  const token = searchParams.get("token");
  const decoded = decodeTestToken(token);

  useEffect(() => {
    if (!decoded) return;
    sessionStorage.setItem(SD_PENDING_KEY, JSON.stringify(decoded));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (!isLoading && user && sessionStorage.getItem(SD_PENDING_KEY)) {
      navigate("/self-discovery/continue", { replace: true });
    }
  }, [isLoading, user, navigate]);

  if (!decoded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white p-6 text-center">
        <p>
          This link is invalid or has expired. Please contact the sender for a
          new one.
        </p>
      </div>
    );
  }

  return <SignIn />;
}
